import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  ADD_APPLICATION,
  DELETE_APPLICATION,
  EDIT_APPLICATION,
  GET_ALL_APPLICATIONS,
  GET_APPLICATION,
  REFRESH_CLIENT_TOKEN,
} from "./actionTypes";
import {
  addApplicationApi,
  getAllApplicationsApi,
  getApplicationApi,
  editApplicationApi,
  deleteApplicationApi,
  refreshClientTokenApi,
} from "api/applications";
import {
  addApplicationFailure,
  addApplicationSuccess,
  deleteApplicationFailure,
  deleteApplicationSuccess,
  editApplicationFailure,
  editApplicationSuccess,
  getAllApplicationsFailure,
  getAllApplicationsSuccess,
  getApplicationFailure,
  getApplicationSuccess,
  refreshClientTokenFailure,
  refreshClientTokenSuccess,
} from "./actions";

function* getAllApplications({ payload }) {
  try {
    const { data } = yield call(getAllApplicationsApi, payload);
    yield put(getAllApplicationsSuccess(data));
  } catch (error) {
    yield put(getAllApplicationsFailure(error.response?.data || error));
  }
}

function* addApplication({ payload }) {
  try {
    const { data } = yield call(addApplicationApi, payload.data);

    yield put(addApplicationSuccess(data));
    payload?.navigate(-1);
  } catch (error) {
    yield put(addApplicationFailure(error.response?.data || error));
  }
}

function* getApplication({ payload }) {
  try {
    const { data } = yield call(getApplicationApi, payload);
    yield put(getApplicationSuccess(data));
  } catch (error) {
    yield put(getApplicationFailure(error.response?.data || error));
  }
}

function* editApplication({ payload }) {
  try {
    const { data } = yield call(editApplicationApi, payload);

    yield put(editApplicationSuccess(data));
    payload?.navigate(-1);
  } catch (error) {
    yield put(editApplicationFailure(error.response?.data || error));
  }
}

function* deleteApplication({ payload }) {
  try {
    yield call(deleteApplicationApi, payload);
    yield put(deleteApplicationSuccess(payload));
  } catch (error) {
    yield put(deleteApplicationFailure(error.response?.data || error));
  }
}
function* refreshClientToken({ payload }) {
  try {
    const { data } = yield call(refreshClientTokenApi, payload);
    yield put(refreshClientTokenSuccess(data));
  } catch (error) {
    yield put(refreshClientTokenFailure(error.response?.data || error));
  }
}

export function* watchGetAllApplications() {
  yield takeEvery(GET_ALL_APPLICATIONS, getAllApplications);
}

export function* watchAddApplication() {
  yield takeEvery(ADD_APPLICATION, addApplication);
}

export function* watchGetApplication() {
  yield takeEvery(GET_APPLICATION, getApplication);
}

export function* watchEditApplication() {
  yield takeEvery(EDIT_APPLICATION, editApplication);
}

export function* watchDeleteApplication() {
  yield takeEvery(DELETE_APPLICATION, deleteApplication);
}
export function* watchRefreshClientToken() {
  yield takeEvery(REFRESH_CLIENT_TOKEN, refreshClientToken);
}

function* applicationsSaga() {
  yield all([
    fork(watchGetAllApplications),
    fork(watchAddApplication),
    fork(watchGetApplication),
    fork(watchEditApplication),
    fork(watchDeleteApplication),
    fork(watchRefreshClientToken),
  ]);
}

export default applicationsSaga;
